"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var AppDefs = window.cccisd && window.cccisd.appDefs;
function visibleRolesForGroup(groupHandle) {
  var visibleRoles = [];
  var roles = (0, _get2["default"])(AppDefs, 'pawn.roles', []);
  var groups = (0, _get2["default"])(AppDefs, 'pawn.groups', []);
  var groupDef = groups.find(function (g) {
    return g.handle === groupHandle;
  });
  if (!groupDef) {
    return visibleRoles;
  }
  var visibleGroups = recurseForVisibleGroups(groupDef, groups);
  var _iterator = _createForOfIteratorHelper(visibleGroups),
    _step;
  try {
    var _loop = function _loop() {
      var visibleGroup = _step.value;
      visibleRoles = visibleRoles.concat((0, _get2["default"])(visibleGroup, 'containsRoles', []));
      visibleRoles = visibleRoles.concat(roles.filter(function (r) {
        var membersOf = r.membersOf || [];
        return membersOf.includes(visibleGroup.handle);
      }).map(function (r) {
        return r.handle;
      }));
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return (0, _sortBy2["default"])(roles.filter(function (r) {
    return visibleRoles.includes(r.handle);
  }), 'label');
}
function recurseForVisibleGroups(groupDef, groups) {
  var visibleGroups = [groupDef];
  var _iterator2 = _createForOfIteratorHelper((0, _get2["default"])(groupDef, 'childGroups', [])),
    _step2;
  try {
    var _loop2 = function _loop2() {
      var childGroupHandle = _step2.value;
      var childGroup = groups.find(function (g) {
        return g.handle === childGroupHandle;
      });
      if (childGroup) {
        visibleGroups = visibleGroups.concat(recurseForVisibleGroups(childGroup, groups));
      }
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return visibleGroups;
}
var _default = exports["default"] = visibleRolesForGroup;